/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/486-html-five2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M.946 0L2.23 14.4 7.992 16l5.777-1.602L15.055 0H.947zm11.722 13.482l-4.644 1.287v.007l-.012-.004-.012.004v-.007l-4.644-1.287L2.258 1.178h11.508l-1.098 12.304zm-2.5-5.198l-.204 2.29-1.972.532-1.967-.53-.126-1.41H4.126l.247 2.774 3.626 1.003 3.615-1.003.485-5.422H5.662l-.161-1.809h6.758l.158-1.766H3.57l.477 5.341z"/>'
  }
})
